'use client';

import { useGsapAnimations } from '@/hooks/useGsapAnimations';

interface AnimatedPageProps {
  children: React.ReactNode;
  className?: string;
}

export function AnimatedPage({ children, className = '' }: AnimatedPageProps) {
  const containerRef = useGsapAnimations();

  return (
    <div ref={containerRef} className={className}>
      {children}
    </div>
  );
}
